import { post } from '@core/api/baseApi';
import { PostAddPatientUserResponse } from '@core/types/ApiResponses';
import { PatientUser } from '@core/types/User';

const setPatientUser = (payload: PatientUser): Promise<PostAddPatientUserResponse> => post(`/UserPatient/${payload.userUid}/add-patient`, payload);

export default setPatientUser;
